export { type GraphemeComponent, graphemeComponentTable } from "#grapheme-component-grapheme-table";
